/**
 * <s-menu-dropdown> — wraps a native <details> header menu so it behaves like a dropdown.
 *
 * The <details>/<summary> pair handles opening and keyboard toggling natively.
 * This component only adds dropdown dismissal: clicking outside, pressing Escape
 * (focus returns to the summary), or tabbing out of the menu closes it.
 */
class SMenuDropdown extends HTMLElement {
  #ac;

  connectedCallback() {
    const details = this.querySelector('details');
    if (!details) return;
    const summary = details.querySelector('summary');
    this.#ac = new AbortController();
    const { signal } = this.#ac;

    document.addEventListener(
      'click',
      (event) => {
        if (details.open && !this.contains(/** @type {Node} */ (event.target))) details.open = false;
      },
      { signal }
    );

    this.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          summary?.focus();
        }
      },
      { signal }
    );

    this.addEventListener(
      'focusout',
      (event) => {
        if (details.open && !this.contains(/** @type {Node} */ (event.relatedTarget))) details.open = false;
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-menu-dropdown')) customElements.define('s-menu-dropdown', SMenuDropdown);
